import styled from 'styled-components';
import { toRem, baseVariables } from '@marriott/mi-ui-library';

const { color, mediaQuery } = baseVariables;

export const StyledCurrentLocation = styled.div`
  .t-label-alt-s {
    padding: ${toRem(14)} 0;
    border-radius: ${toRem(8)};
    @media ${mediaQuery.lg} {
      padding: ${toRem(14)} ${toRem(8)};
    }
    &:hover {
      background-color: ${color.neutral10};
    }
  }

  a {
    display: block;
    text-decoration: none;
  }
`;
